import { createStore } from "vuex";
import modalStore from "./modules/local/modalStore";
import notificationStore from "./modules/local/notificationStore";
import orderStore from "./modules/api/orders/orderStore";
import authStore from "@/store/modules/api/userManagement/authStore";
import userStore from "@/store/modules/api/userManagement/userStore";
import orderItemStore from "@/store/modules/api/orders/orderItemStore";
import paymentStore from "@/store/modules/api/orders/paymentStore";
import refundStore from "@/store/modules/api/orders/refundStore";
import productStore from "@/store/modules/api/inventory/productStore";
import manufacturerStore from "@/store/modules/api/inventory/manufacturerStore";
import categoryStore from "@/store/modules/api/inventory/categoryStore";
import outletStore from "@/store/modules/api/inventory/outletStore";
import discountStore from "@/store/modules/api/inventory/discountStore";
import attributeStore from "@/store/modules/api/inventory/attributeStore";
import reportStore from "@/store/modules/api/reports/reportStore";
import labelSettingsStore from "@/store/modules/local/labelSettingsStore";

export default createStore({
  modules: {
    modal: modalStore,
    notification: notificationStore,
    outlet: outletStore,
    product: productStore,
    manufacturer: manufacturerStore,
    category: categoryStore,
    attribute: attributeStore,
    discount: discountStore,
    order: orderStore,
    orderItem: orderItemStore,
    payment: paymentStore,
    refund: refundStore,
    report: reportStore,
    auth: authStore,
    user: userStore,
    labelSettings: labelSettingsStore,
  },
});
